// extracted by mini-css-extract-plugin
export default {"wrapper":"EmissionReduced_wrapper__Mn9Pg"};